<div class="container-fluid p-3">
  <h2 class="text-center mb-3">Average Stay Report</h2>

  <!-- Filters -->
  <div class="filter-row d-flex flex-wrap gap-3 align-items-center mb-4">
    <mat-form-field appearance="outline">
      <mat-label>Date Range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate [(ngModel)]="start" placeholder="Start date">
        <input matEndDate [(ngModel)]="end" placeholder="End date">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Centre</mat-label>
      <mat-select [(ngModel)]="selectedCentreCode">
        <mat-option value="">All Centres</mat-option>
        <mat-option *ngFor="let c of centres | async" [value]="c.centreCode">
          {{ c.centreName }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-checkbox [(ngModel)]="includeCarryForward"
      matTooltip="Include children admitted before the start date who were still present at the start of the range">
      Consider Carry-Forward Admissions
    </mat-checkbox>

    <button mat-raised-button color="primary" (click)="search()" [disabled]="isLoading">
      <mat-icon>search</mat-icon> Search
    </button>

    <button mat-raised-button color="accent"
            *ngIf="tableRows.length"
            (click)="exportToExcel()">
      <mat-icon>download</mat-icon> Export Excel
    </button>
  </div>

  <!-- Loading -->
  <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>

  <!-- Table -->
  <div *ngIf="tableRows.length && !isLoading" class="table-wrapper mat-elevation-z2">
    <table mat-table [dataSource]="dataSource" class="w-100">

      <!-- Centre Name -->
      <ng-container matColumnDef="centreName">
        <th mat-header-cell *matHeaderCellDef>Centre</th>
        <td mat-cell *matCellDef="let row">{{ row.centreName }}</td>
        <td mat-footer-cell *matFooterCellDef class="grand-total-cell">Grand Total</td>
      </ng-container>

      <!-- New: Count -->
      <ng-container matColumnDef="newCount">
        <th mat-header-cell *matHeaderCellDef>New (Count)</th>
        <td mat-cell *matCellDef="let row">{{ row.newCount }}</td>
        <td mat-footer-cell *matFooterCellDef class="grand-total-cell">{{ grandTotalRow.newCount }}</td>
      </ng-container>

      <!-- New: Avg Days -->
      <ng-container matColumnDef="newAvgDays">
        <th mat-header-cell *matHeaderCellDef>New (Avg Days)</th>
        <td mat-cell *matCellDef="let row">{{ row.newCount ? row.newAvgDays : '—' }}</td>
        <td mat-footer-cell *matFooterCellDef class="grand-total-cell">{{ grandTotalRow.newAvgDays }}</td>
      </ng-container>

      <!-- Follow-Up: Count -->
      <ng-container matColumnDef="followUpCount">
        <th mat-header-cell *matHeaderCellDef>Follow-Up (Count)</th>
        <td mat-cell *matCellDef="let row">{{ row.followUpCount }}</td>
        <td mat-footer-cell *matFooterCellDef class="grand-total-cell">{{ grandTotalRow.followUpCount }}</td>
      </ng-container>

      <!-- Follow-Up: Avg Days -->
      <ng-container matColumnDef="followUpAvgDays">
        <th mat-header-cell *matHeaderCellDef>Follow-Up (Avg Days)</th>
        <td mat-cell *matCellDef="let row">{{ row.followUpCount ? row.followUpAvgDays : '—' }}</td>
        <td mat-footer-cell *matFooterCellDef class="grand-total-cell">{{ grandTotalRow.followUpAvgDays }}</td>
      </ng-container>

      <!-- Carry-Forward: Count -->
      <ng-container matColumnDef="carryForwardCount">
        <th mat-header-cell *matHeaderCellDef
            matTooltip="Admitted before the start date, still present at range start">
          Carry-Forward (Count)
        </th>
        <td mat-cell *matCellDef="let row">{{ includeCarryForward ? row.carryForwardCount : '—' }}</td>
        <td mat-footer-cell *matFooterCellDef class="grand-total-cell">{{ includeCarryForward ? grandTotalRow.carryForwardCount : '—' }}</td>
      </ng-container>

      <!-- Carry-Forward: Avg Days -->
      <ng-container matColumnDef="carryForwardAvgDays">
        <th mat-header-cell *matHeaderCellDef>Carry-Forward (Avg Days)</th>
        <td mat-cell *matCellDef="let row">{{ includeCarryForward && row.carryForwardCount ? row.carryForwardAvgDays : '—' }}</td>
        <td mat-footer-cell *matFooterCellDef class="grand-total-cell">{{ includeCarryForward ? grandTotalRow.carryForwardAvgDays : '—' }}</td>
      </ng-container>

      <!-- Total: Count -->
      <ng-container matColumnDef="totalCount">
        <th mat-header-cell *matHeaderCellDef>Total (Count)</th>
        <td mat-cell *matCellDef="let row">{{ row.totalCount }}</td>
        <td mat-footer-cell *matFooterCellDef class="grand-total-cell">{{ grandTotalRow.totalCount }}</td>
      </ng-container>

      <!-- Total: Avg Days -->
      <ng-container matColumnDef="totalAvgDays">
        <th mat-header-cell *matHeaderCellDef>Total (Avg Days)</th>
        <td mat-cell *matCellDef="let row">{{ row.totalAvgDays }}</td>
        <td mat-footer-cell *matFooterCellDef class="grand-total-cell">{{ grandTotalRow.totalAvgDays }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr>
    </table>
  </div>

  <p *ngIf="!tableRows.length && !isLoading" class="text-center text-muted mt-4">
    Select a date range and click Search.
  </p>
</div>